import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { EntityType } from "../entities/entity.model";
import { FileUploadStatus } from "./dtos/file-upload-status.dto";

export const interfaceActions = createActionGroup({
  source: "Interface",
  events: {
    "Show New Modal": props<{ kind: EntityType }>(),
    "Set File Upload Status": props<FileUploadStatus>(),
    "Clear file uploads": emptyProps(),
    "Clear file upload": props<{ fileId: string }>(),
    "Set Left Pane Route": props<{ route: string }>(),
    "Set Right Pane Route": props<{ route: string }>(),
    "Set New Modal Route": props<{ route: string }>(),
    "Open Context Menu": emptyProps(),
    "Close Context Menu": emptyProps(),
  },
});
